import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [paid, setPaid] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!sessionId) {
      setTimedOut(true);
      return;
    }
    let tries = 0;
    const timer = setInterval(async () => {
      tries += 1;
      try {
        const res = await fetch(`${API}/payments/status/${sessionId}`);
        if (res.ok) {
          const data = await res.json();
          if (data.payment_status === "paid") {
            setPaid(true);
            clearInterval(timer);
            return;
          }
        }
      } catch {
        /* retry */
      }
      if (tries >= 12) {
        clearInterval(timer);
        setTimedOut(true);
      }
    }, 2500);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center bg-white border border-border rounded-3xl p-8 md:p-10" data-testid="payment-success-page">
        <div className="w-16 h-16 mx-auto rounded-full grid place-items-center" style={{ backgroundColor: "#FFE5DE", color: "hsl(var(--coral))" }}>
          <Heart className="w-8 h-8" strokeWidth={2.2} />
        </div>
        <h1 className="mt-6 font-heading text-3xl leading-tight" data-testid="payment-success-title">
          {t("payment.success.title")}
        </h1>
        <p className="mt-4 text-base text-foreground/75 leading-relaxed">{t("payment.success.text")}</p>
        {!paid && !timedOut && (
          <p className="mt-4 inline-flex items-center gap-2 text-sm text-foreground/60" data-testid="payment-success-pending">
            <Loader2 className="w-4 h-4 animate-spin" />
            {t("payment.success.pending")}
          </p>
        )}
        {timedOut && !paid && (
          <p className="mt-4 text-sm text-foreground/60" data-testid="payment-success-unconfirmed">
            {t("payment.success.unconfirmed")}
          </p>
        )}
        <Link
          to="/"
          data-testid="payment-success-back"
          className="mt-8 pill-btn bg-primary text-primary-foreground hover:bg-primary/90 inline-flex justify-center"
        >
          {t("payment.back")}
        </Link>
      </div>
    </main>
  );
}
